/**
 * 李小龍語錄語料（PhilosophySection 走馬燈用）
 * 屬內容語料而非 UI 文案——text 為英文原文，translation 為繁體書面中譯。
 * 放在 src/content/（內容資料層），不入 i18n 字典。
 */
export interface Quote {
  text: string;
  translation: string;
  speaker: string;
}

export const quotes: Quote[] = [
  {
    text: 'Empty your mind, be formless, shapeless, like water.',
    translation: '清空你的心智，無形無狀，像水一樣。',
    speaker: 'Bruce Lee',
  },
  {
    text: 'Absorb what is useful, discard what is not, add what is uniquely your own.',
    translation: '吸收有用的，捨棄無用的，添加你自己獨特的。',
    speaker: 'Bruce Lee',
  },
  {
    text: 'I fear not the man who has practiced 10,000 kicks once, but I fear the man who has practiced one kick 10,000 times.',
    translation: '我不害怕練過一萬種踢法的人，但我害怕一種踢法練過一萬次的人。',
    speaker: 'Bruce Lee',
  },
  {
    text: 'The successful warrior is the average man, with laser-like focus.',
    translation: '成功的戰士只是普通人，但擁有如激光般的專注力。',
    speaker: 'Bruce Lee',
  },
  {
    text: 'Knowing is not enough, we must apply. Willing is not enough, we must do.',
    translation: '知道還不夠，我們必須應用。願意還不夠，我們必須行動。',
    speaker: 'Bruce Lee',
  },
  {
    text: 'Do not pray for an easy life, pray for the strength to endure a difficult one.',
    translation: '不要祈求安逸的生活，要祈求有力量忍受艱難的生活。',
    speaker: 'Bruce Lee',
  },
  {
    text: 'Mistakes are always forgivable, if one has the courage to admit them.',
    translation: '錯誤總是可以被原諒的，只要一個人有勇氣承認它們。',
    speaker: 'Bruce Lee',
  },
  {
    text: 'The key to immortality is first living a life worth remembering.',
    translation: '永生的秘訣首先是過一個值得被記住的人生。',
    speaker: 'Bruce Lee',
  },
  {
    text: 'A wise man can learn more from a foolish question than a fool can learn from a wise answer.',
    translation: '智者從愚蠢的問題中學到的，比愚人從智者的答案中學到的更多。',
    speaker: 'Bruce Lee',
  },
  {
    text: 'Be happy, but never satisfied.',
    translation: '要快樂，但永遠不要滿足。',
    speaker: 'Bruce Lee',
  },
];
